import React, { createContext } from 'react';
import { GenericObject, Permission } from 'v2/models';

const PermissionFlagContext = createContext<GenericObject>({});

function usePermissionFlagContext() {
  const context = React.useContext(PermissionFlagContext);
  if (!context) {
    throw new Error(
      `usePermissionFlagContext must be used within a PermissionFlag`
    );
  }
  return context;
}

function PermissionFlag(props: GenericObject) {
  if (
    props.permissions &&
    hasPermission(
      Object.values(props.permissions),
      props.namePermission,
      props.considerSubscriptionActive
    )
  ) {
    return props.children;
  } else {
    return <></>;
  }
}

function hasPermission(
  permissions: Permission[],
  namePermissions: string[],
  considerSubscriptionActive: boolean | undefined
): boolean {
  const match = permissions.find((permission: Permission) => {
    return considerSubscriptionActive
      ? permission.subscription_active &&
          namePermissions.includes(permission.permission_name)
      : permission.has_access &&
          namePermissions.includes(permission.permission_name);
  });
  return match !== undefined;
}

export { PermissionFlag, usePermissionFlagContext, hasPermission };
